"use client";
import React, { useEffect, useState, useMemo } from "react";
import { Container } from "react-bootstrap";
import SectionTitle from "@/components/common-components/SectionTitle";
import PageTitle from "@/components/common-components/page-title/PageTitle";
import axios from "axios";

import { generateCacheKey, withManualCache } from "@/utlility/cache-service";

const TermsAndCondition = () => {
  const [termsConditionContents, setTermsConditionContents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTermsConditionPage = async () => {
      try {
        const url = `${process.env.NEXT_PUBLIC_API_URL}/api/page-data`;
        const params = {
          organization_key: process.env.NEXT_PUBLIC_ORGANIZATION_KEY,
          slug: "terms-and-conditions",
        };
        const cacheKey = generateCacheKey(url, 'GET', params);

        const result = await withManualCache(cacheKey, async () => {
          const response = await axios.get(url, { params });
          return response.data;
        });

        const data = result?.data?.data || [];

        // Extract the section_contents for the banner-section
        const termsConditionSection = data.find(
          (section) => section.slug === "terms-and-conditions"
        );

        if (termsConditionSection) {
          setTermsConditionContents(termsConditionSection.section_contents || []);
        }
      } catch (error) {
        // console.error("Error fetching terms and condition page data:", error);
        setError("Failed to load content.");
      } finally {
        setLoading(false);
      }
    };
    fetchTermsConditionPage();
  }, []);

  const { header1, header2, description } = useMemo(() => {
    if (!termsConditionContents.length) return {};

    const headers = termsConditionContents
      .filter((item) => item.content_type === "header")
      .sort((a, b) => a.order - b.order);

    const desc = termsConditionContents.find(
      (item) => item.content_type === "html_text"
    );

    return {
      header1: headers[0],
      header2: headers[1],
      description: desc,
    };
  }, [termsConditionContents]);

  if (loading) {
    return (
      <>
        <PageTitle
          image="/images/contact-bg.webp"
          name="Terms & Conditions"
          link={"/terms-and-condition"}
        />
        <section className="terms">
          <Container>
            <div className="text-center py-5">
              <p>Loading...</p>
            </div>
          </Container>
        </section>
      </>
    );
  }

  if (error) {
    return (
      <>
        <PageTitle
          image="/images/contact-bg.webp"
          name="Terms & Conditions"
          link={"/terms-and-condition"}
        />
        <section className="terms">
          <Container>
            <div className="text-center py-5">
              <p className="text-danger">{error}</p>
            </div>
          </Container>
        </section>
      </>
    );
  }

  return (
    <>
      <PageTitle
        image="/images/contact-bg.webp"
        name="Terms & Conditions"
        link={"/terms-and-condition"}
      />
      <section className="terms">
        <Container>
          <SectionTitle
            sectionName={header1?.content}
            title={header2?.content}
            className="text-center"
            style={{ marginBottom: "56px" }}
          />
          <div className="content">
            <div
              className="html-content"
              dangerouslySetInnerHTML={{ __html: description?.content || "" }}
            />
          </div>
        </Container>
      </section>
    </>
  );
};

export default TermsAndCondition;
